import { ToggleButton } from './ToggleButton';

type Props = {
  className?: string;
  onChange?: (value: string) => void;
  options: { label: string; value: string }[];
  selected?: string;
};

export function ToggleButtonGroup({ options, onChange, selected }: Props): React.ReactElement {
  return (
    <span className="isolate inline-flex">
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          selected={option.value === selected}
          onClick={() => onChange?.(option.value)}
        >
          {option.label}
        </ToggleButton>
      ))}
    </span>
  );
}
